import { render } from "./tabs.vue?vue&type=template&id=b9e2bbe6"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"

import "./tabs.vue?vue&type=style&index=0&id=b9e2bbe6&lang=css"
script.render = render

export default script